import { useState, useEffect } from "react";
import { connection } from "utils/apiConnection.ts";
import toast from "react-hot-toast";
import Modal from "react-bootstrap/Modal";
export default function ManagementCommission({ otherInfo, setShow, show }) {
  const [lines, setLines] = useState([]);
  const [supplierInfo, setSupplierInfo] = useState([]);
  const [commission, setCommission] = useState([]);
  const [allComm, setAllComm] = useState("");
  useEffect(() => {
    setLines(otherInfo.line_ids);

    setCommission(
      otherInfo.line_ids.map(v => {
        return { lineId: v.value, percent: "0" };
      })
    );
  }, [otherInfo.line_ids]);

  console.log("commission after effect:", commission);

  // useEffect(() => {
  //   for (let i = 0; i < supplierInfo.length; i++) {
  //   if (otherInfo.suppliers__id == supplierInfo[1].info.suppliers__id) {
  //     setLines(supplierInfo[1].lines_link);
  //   }
  //   }
  //   console.log("line3 : ", lines);
  // }, [supplierInfo]);
  // console.log({ commission });
  const setAllComm1 = () => {
    // for (let i = 0; i < lines.length; i++) {
    //   setCommission(prev => {
    //     return {
    //       ...prev,
    //       [`line_${i}`]: commission.allComm
    //     };
    //   });
    // }

    setCommission(
      commission.map(v => {
        return { ...v, percent: allComm };
      })
    );
    console.log("commission after all", commission);
  };
  const editComm = () => {
    let temp = [];
    let temp1 = "";
    console.log(commission);
    // let fd = new FormData();
    // fd.append("supplier_id", otherInfo.suppliers__id);
    for (let i = 0; i < commission.length; i++) {
      temp.push(`${+commission[i].lineId}=${+commission[i].percent}`);
    }
    // commission.map((value, index) => {
    //   fd.append(`${value.lineId}`, value.percent);
    // });
    // fd.append(`${commission[i].lineId}`, commission[i].percent);
    // fd.append(`line_${i}`, commission[`line_${i}`]);
    // }
    temp1 = temp.toString().replace(/,/g, "/");
    console.log("****", temp1);
    connection("superadminapi/edit_commission", { data: temp1 }).then(data => {
      if (data.status == 1) {
        setCommission(
          commission.map(v => {
            return { ...v, percent: "" };
          })
        );
        toast.success("ویرایش اطلاعات با موفقیت انجام شد");
        setShow(false);
      } else {
        toast.error("مشکلی در ثبت کمیسیون پیش آمده.بعدا تلاش کنید.");
      }
    });
  };
  return (
    <div>
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <div
        // className="modal fade"
        // id="commissionModal"
        // tabIndex={-1}
        // aria-labelledby="commissionModalLabel"
        // aria-hidden="true"
        >
          {/* <div className="modal-dialog"> */}
          <Modal.Dialog>
            {/* <div className="modal-content"> */}
            {/* <div className="modal-header"> */}
            <Modal.Header closeButton>
              <h5
              // className="modal-title" id="commissionModalLabel"
              >
                مدیریت کمیسیون
              </h5>
            </Modal.Header>
            {/* <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setCommission([]);
                }}
              /> */}
            {/* </div> */}
            {/* <div className="modal-body"> */}
            <Modal.Body>
              <div className="d-flex justify-content-center">
                <div className="w-25 mx-3">
                  <input
                    type="text"
                    className="form-control"
                    value={allComm}
                    onChange={e => {
                      e.persist();
                      try {
                        if (isNaN(e.target.value))
                          throw new Error("لطفا عدد را به درستی وارد نمایید.");
                        setAllComm(e.target.value);
                        console.log("allcommm", allComm);
                      } catch (ex) {
                        toast.error(ex.message);
                      }
                    }}
                  />
                </div>
                <button
                  type="button"
                  className="btn btn-outline-success"
                  onClick={setAllComm1}
                >
                  اجرای گروهی
                </button>
              </div>
              <div className="mt-4">
                <ol>
                  {lines.length > 0 ? (
                    lines.map((value, index) => {
                      return (
                        <li>
                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <label htmlFor={`line-${index}`} className="w-50">
                              {value.label}
                            </label>
                            <div className="w-25 ">
                              <input
                                type="text"
                                id={`line-${index}`}
                                // name=""
                                // value={commission[`line_${index}`]}
                                value={commission[index]?.percent}
                                className="form-control"
                                onChange={e => {
                                  e.persist();
                                  try {
                                    if (isNaN(e.target.value))
                                      throw new Error(
                                        "لطفا عدد را به درستی وارد نمایید"
                                      );

                                    setCommission(
                                      commission.map((v, i) => {
                                        console.log("i", i);
                                        console.log("index", index);
                                        if (i == index) {
                                          // if (v.lindId == value.value) {
                                          // console.log("lindId", value.lindId);
                                          return {
                                            ...v,
                                            percent: e.target.value
                                          };
                                        }
                                        return v;
                                      })
                                    );
                                  } catch (ex) {
                                    toast.error(ex.message);
                                  }
                                  console.log("line percent : ", commission);
                                }}
                              />
                            </div>
                          </div>
                        </li>
                      );
                    })
                  ) : (
                    <p>هیچ لاینی وجود ندارد.</p>
                  )}
                </ol>
              </div>
            </Modal.Body>
            {/* </div> */}
            {/* <div className="modal-footer"> */}
            <Modal.Footer>
              <button
                type="button"
                className="btn btn-secondary"
                // data-bs-dismiss="modal"
                onClick={() => {
                  setShow(false);
                }}
              >
                بستن
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={editComm}
              >
                ذخیره
              </button>
            </Modal.Footer>
            {/* </div> */}
            {/* </div> */}
            {/* </div> */}
          </Modal.Dialog>
        </div>
      </Modal>
    </div>
  );
}
